"use strict";

class SuperPublicHolidaysDeveloperController {

    constructor(
        Upload,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper() && self.SSUserService.hasPermission('PUBLIC_HOLIDAY_DEVELOPER_MANAGE')) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.URL_BASE = 'sec/super/public-holidays/developer';

        self.developers = [];
        self.dict_developers = {};

        self.publicHolidays = null;
        self.publicHolidaysTotalCount = null;
        self.publicHolidaysPagesCount = null;
        self.publicHolidaysPagesArray = [];

        self.publicHolidayParams = {
            developer_id: '',
            country_code: '',
            from: '',
            to: '',
            pageNo: 1,
            offset: 0,
            limit: 20,
            send_total_count: 1
        };

        self.selectedPublicHoliday = null;
        self.publicHolidayForm = {};
        self.publicHolidayViewMode = false;
        self.publicHolidayEditMode = false;
        self.formErrors = {};

        self.loadDevelopers();
        self.getPublicHolidays();
    }

    //-------------------------------------------

    loadDevelopers() {
        const self = this;
        const url = 'developers/';
        const params = { limit: 1000 };

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.developers = response.data.developers || [];
            self.developers.forEach(function (d) {
                self.dict_developers[d.id] = d.name;
            });
        });
    }

    //-------------------------------------------

    buildQueryParams() {
        const self = this;
        const p = {
            offset: self.publicHolidayParams.offset,
            limit: parseInt(self.publicHolidayParams.limit) || 20,
            send_total_count: 1,
            order: '{"holiday_date":"asc"}'
        };
        if (self.publicHolidayParams.developer_id) {
            p.developer_id = parseInt(self.publicHolidayParams.developer_id);
        }
        if (self.publicHolidayParams.country_code) {
            p.country_code = parseInt(self.publicHolidayParams.country_code);
        }
        if (self.publicHolidayParams.from) {
            p.from = self.SSUtilService.formatDateToStore(self.publicHolidayParams.from);
        }
        if (self.publicHolidayParams.to) {
            p.to = self.SSUtilService.formatDateToStore(self.publicHolidayParams.to);
        }
        return p;
    }

    getPublicHolidays() {
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest(self.URL_BASE, self.buildQueryParams()).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.publicHolidays = response.data.public_holidays || [];
            self.publicHolidaysTotalCount = response.data.total_count || 0;
            self.preparePagination();
        });
    }

    preparePagination() {
        const self = this;
        const limit = parseInt(self.publicHolidayParams.limit) || 20;
        self.publicHolidaysPagesCount = Math.ceil(self.publicHolidaysTotalCount / limit);
        self.publicHolidaysPagesArray = [];
        for (let i = 0; i < self.publicHolidaysPagesCount; i++) {
            self.publicHolidaysPagesArray.push(i + 1);
        }
        if (self.publicHolidaysPagesCount < self.publicHolidayParams.pageNo) {
            self.publicHolidayParams.pageNo = 1;
        }
    }

    setPageNoAndLoadPublicHolidays(pageNo) {
        const self = this;
        if (pageNo) {
            if (pageNo === 'next') {
                pageNo = parseInt(self.publicHolidayParams.pageNo) + 1;
            } else if (pageNo === 'previous') {
                pageNo = parseInt(self.publicHolidayParams.pageNo) - 1;
            } else {
                pageNo = parseInt(pageNo);
            }
            if (pageNo > self.publicHolidaysPagesCount) pageNo = self.publicHolidaysPagesCount;
            if (pageNo < 1) pageNo = 1;
            if (pageNo == self.publicHolidayParams.pageNo) return;
            self.publicHolidayParams.pageNo = pageNo;
        }
        self.publicHolidayParams.offset = (parseInt(self.publicHolidayParams.pageNo) - 1) * (parseInt(self.publicHolidayParams.limit) || 20);
        self.getPublicHolidays();
    }

    setLimitAndLoadPublicHolidays() {
        const self = this;
        self.publicHolidayParams.pageNo = 1;
        self.publicHolidayParams.offset = 0;
        self.getPublicHolidays();
    }

    applyFilters() {
        const self = this;
        self.publicHolidayParams.pageNo = 1;
        self.publicHolidayParams.offset = 0;
        self.getPublicHolidays();
    }

    clearFilters() {
        const self = this;
        self.publicHolidayParams.developer_id = '';
        self.publicHolidayParams.country_code = '';
        self.publicHolidayParams.from = '';
        self.publicHolidayParams.to = '';
        self.publicHolidayParams.pageNo = 1;
        self.publicHolidayParams.offset = 0;
        self.getPublicHolidays();
    }

    //-------------------------------------------

    setPublicHolidayViewMode(mode, publicHoliday) {
        const self = this;
        self.formErrors = {};

        if (mode) {
            self.selectedPublicHoliday = publicHoliday || null;
            if (publicHoliday) {
                self.publicHolidayForm = angular.copy(publicHoliday);
                if (self.publicHolidayForm.holiday_date) {
                    self.publicHolidayForm.holiday_date = self.SSUtilService.formatUtcToLocalDate(self.publicHolidayForm.holiday_date);
                }
                self.setPublicHolidayEditMode(false);
            } else {
                self.publicHolidayForm = {};
                if (self.publicHolidayParams.developer_id) {
                    self.publicHolidayForm.developer_id = self.publicHolidayParams.developer_id;
                }
                if (self.publicHolidayParams.country_code) {
                    self.publicHolidayForm.country_code = self.publicHolidayParams.country_code;
                }
                self.setPublicHolidayEditMode(true);
            }
        } else {
            self.selectedPublicHoliday = null;
            self.publicHolidayForm = {};
            self.setPublicHolidayEditMode(false);
        }

        self.publicHolidayViewMode = !!mode;

        if (self.publicHolidayViewMode) {
            setTimeout(function () {
                $('#dev_holiday_date').datepicker({dateFormat: 'dd/mm/yy'});
            }, 100);
        }
    }

    setPublicHolidayEditMode(mode) {
        const self = this;
        self.formErrors = {};
        self.publicHolidayEditMode = !!mode;
        if (mode) {
            setTimeout(function () {
                $('#dev_holiday_date').datepicker({dateFormat: 'dd/mm/yy'});
            }, 100);
        }
    }

    //-------------------------------------------

    savePublicHoliday() {
        const self = this;
        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            self._savePublicHoliday();
        });
    }

    _savePublicHoliday() {
        const self = this;
        self.SSAlertService.clear();

        if (!self.publicHolidayForm) return;

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#developerHolidayForm'))) {
            self.SSAlertService.danger('Please correct the following errors before you proceed.');
            return;
        }

        const params = angular.copy(self.publicHolidayForm);
        params.holiday_date = self.SSUtilService.formatDateToStore(params.holiday_date);
        params.country_code = parseInt(params.country_code);
        if (params.developer_id) {
            params.developer_id = parseInt(params.developer_id);
        }

        let url = self.URL_BASE;

        const responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.formErrors = self.SSHttpService.parseErrors(response) || {};
                if (response.sub_code == 412003) {
                    self.SSAlertService.danger('Wrong scope',
                        'This holiday belongs to the global calendar; edit it from the Global Holidays screen.');
                } else {
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }

            self.SSAlertService.success('Success!', 'Developer holiday saved.');
            self.setPublicHolidayViewMode(false);
            self.applyFilters();
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            // backend preserves developer_id when omitted on edit
            delete params.developer_id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    deletePublicHoliday(id) {
        const self = this;
        if (!id) return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this developer holiday?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                const url = self.URL_BASE + '/' + id;
                loading(true);
                self.SSHttpService.deleteAPIRequest(url, {}).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.sub_code == 412003) {
                            self.SSAlertService.danger('Wrong scope',
                                'This holiday belongs to the global calendar; edit it from the Global Holidays screen.');
                        } else {
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }
                    jQuery.each(self.publicHolidays, function (i, o) {
                        if (o.id == id) {
                            self.publicHolidays.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Success!', 'Developer holiday deleted.');
                });
            }
        );
    }
}

SuperPublicHolidaysDeveloperController.$inject = [
    'Upload',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('SuperPublicHolidaysDeveloperController', SuperPublicHolidaysDeveloperController);
